<div class="app-alerts" [ngClass]="position">
  <ng-container *ngIf="position == 'left' else right">
    <div class="app-alert"
         [ngClass]="alert.type"
         [@animationLeft]="'shown'"
         (click)="close(alert)"
         *ngFor="let alert of alerts | async">

      <div class="prefix">
      </div>
      <div class="content" *ngIf="!alert.content.html">{{alert.content}}</div>
      <div class="content" *ngIf="!!alert.content.html" [innerHTML]="alert.content.html"></div>
    </div>
  </ng-container>
  <ng-template #right>
    <div class="app-alert"
         [ngClass]="alert.type"
         [@animationRight]="'shown'"
         (click)="close(alert)"
         *ngFor="let alert of alerts | async">

      <div class="prefix">
      </div>
      <div class="content" *ngIf="!alert.content.html">{{alert.content}}</div>
      <div class="content" *ngIf="!!alert.content.html" [innerHTML]="alert.content.html"></div>
    </div>
  </ng-template>
</div>
